// extracted by mini-css-extract-plugin
module.exports = {"bulk-action":"unassigned-tasks_bulk-action__nS44c","count":"unassigned-tasks_count__1tZbz"};